import './TextField.css'

/**
 * Text input. Pass `icon` for a leading glyph and `trailing` for an adornment
 * pinned to the end (a password reveal button, for example).
 */
export default function TextField({
  id,
  type = 'text',
  value,
  onChange,
  icon: Icon,
  trailing,
  floatingLabel,
  invalid = false,
  className = '',
  ...rest
}) {
  const input = (
    <input
      id={id}
      type={type}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      aria-invalid={invalid || undefined}
      /* A non-empty placeholder is what :placeholder-shown keys off, so the
         floating variant uses a space rather than visible text. */
      placeholder={floatingLabel ? ' ' : rest.placeholder}
      className={[
        'text-field',
        Icon && 'text-field--with-icon',
        trailing && 'text-field--with-trailing',
        floatingLabel && 'text-field--floating',
        invalid && 'text-field--invalid',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  )

  if (!Icon && !trailing && !floatingLabel) return input

  return (
    <div className={`field${floatingLabel ? ' field--floating' : ''}`}>
      {input}
      {floatingLabel && (
        <label className="field__label" htmlFor={id}>
          {floatingLabel}
        </label>
      )}
      {Icon && (
        <span className="field__icon" aria-hidden="true">
          <Icon size={17} />
        </span>
      )}
      {trailing && <span className="field__trailing">{trailing}</span>}
    </div>
  )
}
